import TopBanner from "../../components/common/TopBanner";
import TextImageContainer from "../../components/common/TextImageContainer";
import BannerLanding from "./BannerLanding";
import JoinUsBanner from "./JoinUsBanner";

import TopBannerImgMobile from "../../assets/background/bgheroMobile.png";
import TopBannerImg from "../../assets/background/Group40.png";
import icon2 from "../../assets/background/orderTab.png"

// icons used in
const icon1 =
  "https://staging-olin.sgp1.digitaloceanspaces.com/landingpage/002f0f3885cb88c34a50d7eff0c788292ffee7fdc352c8b9d472e62dddf310db.jpg";
const icon3 =
  "https://staging-olin.sgp1.digitaloceanspaces.com/landingpage/852f0a408e2a45ea80573bab159e3e2a9bff9a8c0338ca53dafb63a56ba28be7.jpg";
const MultDeviceImg =
  "https://staging-olin.sgp1.digitaloceanspaces.com/landingpage/9d7f74e9ee102360216839e2979e5c659995b531c404d16bbe9a5e0724552577.png";


const truckStall = (
  <svg
    width="100%"
    height="100%"
    viewBox="-6 -7 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.377344 5.63184L3.45047 2.38619H3.43453V0.357849H21.8736V2.38636H21.8897L24.9628 5.632H0.377344V5.63184ZM22.5566 14.8085H25.7494V28.6821H23.5883H23.2531C23.1563 28.6821 23.0769 28.6179 23.0592 28.5172C22.7948 26.9409 21.4725 25.7405 19.877 25.7405C18.2816 25.7405 16.9592 26.9409 16.6947 28.5172C16.677 28.6088 16.5978 28.6821 16.5008 28.6821H12.8548C12.3848 28.6821 12.0039 28.2861 12.0039 27.7974V25.6125H0.3125V23.9898H2.65391V10.1892C1.30891 9.8331 0.3125 8.60232 0.3125 7.11716V6.34185H24.898V7.10693C24.898 8.59208 23.8777 9.8331 22.5566 10.189V14.8085ZM12.0039 23.9898V14.8085H20.9956V10.1643C19.6717 9.8076 18.6909 8.57454 18.6909 7.08695C18.6909 8.14668 17.7514 10.2764 15.6311 10.2764C13.2844 10.2764 12.5614 8.20776 12.5614 7.08695C12.5614 8.2893 11.6333 10.2787 9.51734 10.2787C7.08109 10.2787 6.42203 7.74384 6.42203 7.08695C6.42203 8.5747 5.44141 9.80776 4.11734 10.1643V23.9898H12.0039ZM22.3011 29.122C22.3011 30.5148 21.2169 31.6422 19.8769 31.6422C18.537 31.6422 17.4527 30.515 17.4527 29.122C17.4527 27.7289 18.5369 26.6017 19.8769 26.6017C21.2169 26.6019 22.3011 27.7291 22.3011 29.122ZM20.8055 29.122C20.8055 28.5929 20.3859 28.1566 19.8769 28.1566C19.368 28.1566 18.9483 28.5927 18.9483 29.122C18.9483 29.6512 19.3678 30.0873 19.8769 30.0873C20.3859 30.0873 20.8055 29.6512 20.8055 29.122ZM39.6875 27.0692V27.7474C39.6875 28.2605 39.2908 28.6822 38.7883 28.6822H38.4533C38.3563 28.6822 38.277 28.6181 38.2594 28.5174C37.9948 26.9411 36.6727 25.7407 35.0772 25.7407C33.4817 25.7407 32.1594 26.9411 31.895 28.5174C31.8773 28.609 31.798 28.6822 31.7011 28.6822H26.507V18.0792H30.1748C30.4305 18.0883 30.6773 18.1983 30.8536 18.3816L33.993 22.7804C34.0283 22.8171 34.0811 22.8446 34.1341 22.8446H37.572C38.3566 22.8446 38.9825 23.4953 38.9825 24.3016V26.8768H39.4937C39.5994 26.8768 39.6875 26.9684 39.6875 27.0692ZM32.2564 22.4963L30.2012 19.243C30.1572 19.2063 30.1042 19.1789 30.0514 19.1789H27.7881C27.6823 19.1789 27.5942 19.2705 27.5942 19.3805V22.6428C27.5942 22.7528 27.6823 22.8444 27.7881 22.8444H32.1066C32.2739 22.8446 32.3622 22.6337 32.2564 22.4963ZM37.5014 29.122C37.5014 30.5148 36.4172 31.6422 35.0772 31.6422C33.7372 31.6422 32.653 30.515 32.653 29.122C32.653 27.7289 33.7372 26.6017 35.0772 26.6017C36.4172 26.6017 37.5014 27.7291 37.5014 29.122ZM36.0058 29.122C36.0058 28.5929 35.5863 28.1566 35.0772 28.1566C34.5681 28.1566 34.1486 28.5927 34.1486 29.122C34.1486 29.6512 34.5681 30.0873 35.0772 30.0873C35.5863 30.0873 36.0058 29.6512 36.0058 29.122Z"
      fill="white"
    />
  </svg>
);

const payment = (
  <svg
    width="100%"
    height="100%"
    viewBox="-5 -6 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.09441 7.45003C9.49152 7.45003 9.88474 7.37179 10.2516 7.21979C10.6185 7.06778 10.9518 6.84499 11.2325 6.56413C11.5133 6.28328 11.7359 5.94986 11.8878 5.58294C12.0396 5.21601 12.1177 4.82276 12.1175 4.42565C12.1175 4.02865 12.0393 3.63553 11.8874 3.26875C11.7355 2.90197 11.5128 2.5687 11.2321 2.28798C10.9514 2.00726 10.6181 1.78457 10.2513 1.63265C9.88453 1.48072 9.49142 1.40253 9.09441 1.40253C8.69741 1.40253 8.3043 1.48072 7.93751 1.63265C7.57073 1.78457 7.23747 2.00726 6.95674 2.28798C6.67602 2.5687 6.45334 2.90197 6.30141 3.26875C6.14948 3.63553 6.07129 4.02865 6.07129 4.42565C6.07145 5.2275 6.38997 5.99647 6.95685 6.56358C7.52372 7.13069 8.29257 7.44953 9.09441 7.45003Z"
      fill="white"
    />
    <path
      d="M31.7829 7.40751C32.5974 7.40734 33.3786 7.08373 33.9546 6.50781C34.5307 5.9319 34.8544 5.15081 34.8548 4.33626C34.8548 3.52179 34.5312 2.74069 33.9553 2.16478C33.3794 1.58886 32.5983 1.26532 31.7838 1.26532C30.9694 1.26532 30.1883 1.58886 29.6123 2.16478C29.0364 2.74069 28.7129 3.52179 28.7129 4.33626C28.7127 4.73952 28.792 5.13887 28.9462 5.51148C29.1004 5.88409 29.3265 6.22267 29.6116 6.50788C29.8967 6.79309 30.2352 7.01934 30.6078 7.1737C30.9803 7.32806 31.3796 7.40751 31.7829 7.40751Z"
      fill="white"
    />
    <path
      d="M7.97777 24.6613C4.00277 24.6613 0.780273 27.8831 0.780273 31.8581C0.780273 35.8331 4.00277 39.0556 7.97777 39.0556C11.9528 39.0556 15.1753 35.8331 15.1753 31.8581C15.1753 27.8838 11.9528 24.6613 7.97777 24.6613ZM8.8309 36.4269V37.5769H7.11027V36.4269C5.27527 36.2169 4.10465 34.47 4.10465 33.3281H5.93902C5.93902 33.8413 6.33465 34.5231 7.12715 34.6863V32.53C6.73152 32.4538 6.51027 32.3913 6.0859 32.275C5.00152 31.9756 4.2509 31.0625 4.2509 29.8988C4.2509 28.7456 5.37652 27.4519 7.1109 27.2225V26.1481H8.83152V27.2225C10.6709 27.4594 11.8021 28.8181 11.8021 30.1763L10.0053 30.1756C10.004 29.5819 9.51027 29.0425 8.83152 28.9763V30.9988C9.3309 31.1088 9.3309 31.0963 9.78965 31.2213C11.5009 31.6869 11.8865 32.8069 11.8865 33.7463C11.8859 35.1888 10.7328 36.1788 8.8309 36.4275V36.4269Z"
      fill="white"
    />
    <path
      d="M7.1098 30.6825C6.34105 30.5456 6.12793 30.2169 6.12793 29.8619C6.12793 29.4475 6.64918 29.0481 7.1098 28.9944V30.6825ZM8.85105 34.6781V32.8556C9.61043 32.9644 10.0917 33.2913 10.0917 33.7606C10.0917 34.1756 9.64355 34.6481 8.85105 34.6781Z"
      fill="white"
    />
    <path
      d="M5.14902 12.6875H6.3409L4.9634 17.8144H13.2253L11.8478 12.6875H13.0396L14.4515 17.8144H17.1096L15.404 11.5957C14.949 10.0919 13.4609 8.49628 11.5109 8.49628H6.6759C4.72402 8.49628 3.23652 10.0913 2.7809 11.5957L1.07715 17.8144H3.73527L5.1484 12.6875H5.14902Z"
      fill="white"
    />
    <path
      d="M35.0646 8.46564C35.7891 8.46547 36.484 8.75303 36.9965 9.26508C37.509 9.77714 37.7972 10.4718 37.7977 11.1963L37.7933 19.58H39.5527V23.0169L35.9927 23.0188V37.2525C35.9927 38.2475 35.1764 39.0544 34.1808 39.0544C33.7032 39.0539 33.2453 38.8639 32.9077 38.526C32.5701 38.1882 32.3804 37.7301 32.3802 37.2525V23.02H31.2321V37.2525C31.2317 37.7306 31.0415 38.189 30.7033 38.5269C30.365 38.8648 29.9064 39.0546 29.4283 39.0544C28.9497 39.0546 28.4905 38.865 28.1514 38.5273C27.8122 38.1895 27.6208 37.7311 27.6189 37.2525V23.0213L0.77832 23.0294V19.58H27.6189V11.5081L21.8852 18.2969C20.6789 19.69 18.5308 17.95 19.7414 16.46L25.6827 9.32189C26.0671 8.93939 26.4114 8.46564 27.8302 8.46564H35.0633H35.0646Z"
      fill="white"
    />
  </svg>
);

const box = (
  <svg
    width="100%"
    height="100%"
    viewBox="-5 -6 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.6243 6.51529C39.5749 6.49881 20.2557 0.0618149 20.2557 0.0618149C20.0826 -0.020605 19.9178 -0.020605 19.7447 0.0618149L0.631509 6.35045C0.153474 6.54826 0.0380859 6.96036 0.0380859 7.19937V33.0215C0.0380859 33.4501 0.293587 33.788 0.631509 33.8704L19.5057 39.9036C19.7941 40.0107 20.1073 40.0519 20.5029 39.9036L39.3688 33.8704C39.7068 33.6974 39.9623 33.3594 39.9623 33.0215V7.19937C39.9623 6.94387 39.8798 6.68837 39.6243 6.51529ZM20.0002 1.84208L36.3935 7.10871L30.2037 9.09503L14.0495 3.77895L20.0002 1.84208ZM19.1512 37.942L1.73593 32.4198V8.4027L19.1512 13.9743V37.942ZM20.0002 12.3753L3.60687 7.19937L11.3296 4.67733L27.4262 9.99341L20.0002 12.3753ZM20.8491 37.942V13.9083L29.5114 11.1638V13.8259L31.2093 13.1006V10.628L38.2562 8.4027V32.3374H38.2644L20.8491 37.942Z"
      fill="white"
    />
  </svg>
);

const Landing = () => {
  return (
    <>
      <TopBanner
        desktopImg={TopBannerImg}
        mobileImg={TopBannerImgMobile}
        hasButton={true}
        title="Tingkatkan kesehatan Bangsa mulai dari Apotek dengan OLIN"
        subtitle={
          <>
            Bisnis apotek baik bukan hanya tentang menjual obat, <br />
            namun juga membantu kesehatan masyarakat
          </>
        }
      />
      <TextImageContainer
        align="left"
        content={
          <div className="flex flex-col">
            <p className="font-bold text-[25px] md:text-[40px] text-left mt-5 md:mt-10">
              Semua Mudah dengan OLIN!
            </p>
            <p className="font-light text-[15px] lg:font-medium lg:text-[20px] mt-4">
              Miliki kemudahan dengan bermitra bersama OLIN. Segala kebutuhan
              dan dukungan yang Anda butuhkan dalam mengembangkan bisnis apotek
              dalam satu aplikasi pintar.
            </p>

            <div className="flex flex-col gap-4 font-medium text-[19px]">
              <div className="flex flex-row items-center gap-4 mt-10">
                <div className="w-[59px] rounded-full bg-[#24337A] flex justify-center items-center p-2">
                  {truckStall}
                </div>
                <p>Kelola inventaris antar platform dengan mudah.</p>
              </div>
              <div className="flex flex-row items-center gap-4">
                <div className="w-[59px] rounded-full bg-[#24337A] flex justify-center items-center p-2">
                  {payment}
                </div>
                <p>
                  Terintegrasi dengan pesanan
                  <span className="italic font-medium"> telemedicine</span>
                </p>
              </div>
              <div className="flex flex-row items-center gap-4 mt-3">
                <div className="w-[59px] rounded-full bg-[#24337A] flex justify-center items-center p-2">
                  {box}
                </div>
                <p>Pantau bisnis kapanpun & dimanapun</p>
              </div>
            </div>
          </div>
        }
        imgSrc={MultDeviceImg}
        aosImg="fade-up"
        aosText="fade-up"
      />

      <TextImageContainer
        align="right"
        content={
          <div className="flex flex-col">
            <p className="font-bold text-[25px] md:text-[40px] text-left mt-5 md:mt-10">
              Atur inventaris apotek secara mudah & sistematis
            </p>
            <p className="font-light md:font-medium text-[20px] md:text-[15px] mt-4">
              Melalui sistem yang tersentralisasi, OLIN dapat memberikan
              kemudahan dalam proses stok-up produk di apotek offline dan online
              anda hanya dengan satu klik.
            </p>
          </div>
        }
        imgSrc={icon1}
        aosImg="fade-up"
        aosText="fade-up"
      />
      <TextImageContainer
        align="left"
        content={
          <div className="flex flex-col">
            <p className="font-bold text-[25px] md:text-[40px] text-left mt-4 md:mt-10">
              Seluruh kebutuhan Apotek Anda dalam satu aplikasi!
            </p>
            <p className="font-light md:font-medium text-[20px] md:text-[15px] mt-4">
              OLIN memberikan kemudahan bagi para pengguna agar dapat &
              melakukan aktivitas apotek seperti penjualan dalam toko dan
              menerima pesanan online dalam satu layar.
            </p>
          </div>
        }
        imgSrc={icon2}
        aosImg="fade-up"
        aosText="fade-up"
      />
      <TextImageContainer
        align="right"
        content={
          <div className="flex flex-col">
            <p className="font-bold text-[25px] md:text-[40px] text-left mt-5 md:mt-10">
              Kembangkan bisnis dengan mitra yang terpercaya!
            </p>
            <p className="font-light md:font-medium text-[20px] md:text-[15px] mt-4">
              Dengan OLIN, Anda dapat memonitor kesehatan bisnis & bekerjasama
              dengan mitra produk farmasi yang dipastikan keasliannya, memiliki
              ijin BPOM Indonesia dan mendistribusikan produk menurut Cara
              Distribusi Obat yang Baik (CDOB), kapanpun & dimanapun melalui
              aplikasi OLIN.
            </p>
          </div>
        }
        imgSrc={icon3}
        aosImg="fade-up"
        aosText="fade-up"
      />

      <BannerLanding />
      <JoinUsBanner />
    </>
  );
};

export default Landing;
